import { Image, Text, VStack } from '@chakra-ui/react';

export const Header = () => {
  return (
    <VStack w={'100%'} h="100%" justifyContent="center" alignItems="center" position="relative">
      <Image src="/assets/image1.jpeg" alt="background image" width={'100%'} height={'100%'} objectFit="cover" />
      <VStack
        position="absolute"
        top={0}
        left={0}
        w="100%"
        h="100%"
        bg="rgba(245, 245, 245, 0.8)"
        justifyContent="center"
        alignItems="center"
        color="black"
        textAlign="center"
        spacing={0}
      >
        <Text fontSize={{ base: '24px', sm: '28px', md: '32px', lg: '36px', xl: '40px' }} color="black" fontWeight="bold">
          Building Digital Experiences
        </Text>
        <Text fontSize={{ base: '14px', sm: '14px', md: '14px', lg: '16px', xl: '18px' }} color="gray.600">
          Full-stack Developer specializing in mobile and web applications
        </Text>
      </VStack>
    </VStack>
  );
};
